var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.contactPerson)?_c('div',[_c('ContactPerson',{attrs:{"contactPerson":_vm.contactPerson,"logo":_vm.logo}}),_c('div',{staticClass:"col-12 mt-auto order-first pt-4"},[_c('SimpleSocialMediaArea')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }